<template>
  <v-dialog v-model="edits.videoModal" :full-width="false" max-width="1200" :persistent="true">
    <v-form ref="form" v-model="valid" lazy-validation v-if="edits.videoModal">
      <v-card>
        <v-card-title class="black">
          <h2 class="pl-2 text-uppercase font-weight-light">
            {{title}}
          </h2>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm4>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-select
                      :items="platforms"
                      label="Platform *"
                      v-model="formData.platform"
                      item-text="name"
                      item-value="id"
                      color="secondary"
                      :disabled="!!edits.video || busy"
                      hint="Video Platform. Cannot be changed once saved."
                      :rules="rules.platform"/>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="ID *"
                      color="secondary"
                      v-model="formData.remote_id"
                      :disabled="!!edits.video || busy"
                      :rules="rules.remote_id"
                      hint="Video ID from the URL. Cannot be changed once saved."/>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="filteredTypes"
                      label="Video Category *"
                      v-model="formData.category"
                      item-text="name"
                      item-value="id"
                      color="secondary"
                      :disabled="busy"
                      :rules="rules.category"/>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Description"
                      v-model="formData.description"
                      color="secondary"
                      :disabled="busy"
                      hint="Optional. Useful to mention who's in the video, the set creator, etc."/>
                  </v-flex>
                  <v-flex xs12 v-if="admin">
                    <v-checkbox
                      label="Editor's Choice"
                      v-model="formData.editor_choice"
                      :true-value="true"
                      :false-value="false"
                      color="secondary"/>
                  </v-flex>
                  <!-- <v-flex xs12 v-if="editor">
                    <v-checkbox
                      label="Locked"
                      v-model="formData.locked"
                      :true-value="true"
                      :false-value="false"
                      hint="Restricts edits to Editors and Admins only."
                      color="secondary"/>
                  </v-flex> -->
                  <v-flex>
                    <v-divider></v-divider>
                    <v-layout>
                      <v-flex xs4 class="mt-2">
                        <small class="ml-2">* Required fields</small>
                      </v-flex>

                      <v-flex xs8 class="mt-2 text-xs-right">
                        <v-btn color="secondary" flat :disabled="busy" @click="close()">Close</v-btn>
                        <v-btn color="secondary black--text" :disabled="busy" @click="submit()">Save Video</v-btn>
                        <p v-if="message">{{message}}</p>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm1 hidden-xs class="text-xs-center">
                <v-divider vertical class="grey"/>
              </v-flex>
              <v-flex xs12 sm7>
                <div v-if="!(edits.video && edits.video.id)" class="subheading font-weight-light">
                  <p>Once the video is saved, you will be able to add songs to it.</p>
                  <div v-if="edits.song">
                    <p>The following song will be automatically once you save the video:</p>
                    <p><b>{{edits.song.ac}}</b></p>
                  </div>
                </div>

                <v-layout column v-else>
                  <table class="video-song-list">
                    <caption>
                      {{songLabel}}
                    </caption>
                    <thead>
                      <tr class="grey black--text">
                        <th class="pl-1">Song</th>
                        <th style="width: 60px">Start</th>
                        <th style="width: 60px">End</th>
                        <th style="width: 10px">Save</th>
                        <th style="width: 10px">Del</th>
                      </tr>
                    </thead>
                    <tbody v-if="!!edits.video">
                      <video-song-edit
                        v-for="(vs, index) of videoSongs"
                        :key="index"
                        :video="edits.video"
                        :video-songs.sync="videoSongs"
                        :video-song="vs"
                      />
                    </tbody>
                  </table>
                  <v-flex>
                    <v-layout>
                      <v-flex class="mt-2 text-xs-left">
                        <v-btn color="secondary black--text" :disabled="busy" @click="addSong()">Add Song</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import videoTypes from '../constants/video-types'
import { setVideoSongs, sortByNewestVideo, generateUniqueId } from '../services/database'

export default {
  name: 'video-edit-modal',
  props: {
    edits: Object
  },
  data () {
    return {
      valid: true,
      busy: false,
      message: '',
      formData: {
        platform: null,
        remote_id: null,
        category: null,
        description: null,
        editor_choice: null,
        locked: false,
        song_id: null
      },
      videoSongs: [],
      signedIn: false,
      editor: false,
      admin: false,
      platforms: [
        { id: 'yt', name: 'YouTube' }
      ],
      types: videoTypes,
      rules: {
        platform: [
          v => !!v || 'Platform is required.'
        ],
        remote_id: [
          v => !!v || 'Video ID is required.'
        ],
        category: [
          v => !!v || 'Category is required.'
        ]
        // sng: [
        //   v => (v && v.length > 0) || 'Song or Tracklist is required.'
        // ]
      }
    }
  },
  computed: {
    title () {
      var video = this.edits.video
      if (video && video.id) {
        return `Edit Video #${video.id}`
      } else {
        return 'Add Video'
      }
    },
    songLabel () {
      if (this.multiple) {
        return 'Tracklist *'
      } else {
        return 'Song *'
      }
    },
    multiple () {
      var category = this.formData.category
      return category !== 'fr' && category !== 'cc' && category !== 'au'
    },
    filteredTypes () {
      if (this.editor || this.admin) return this.types
      return this.types.filter(t => !t.editor)
    }
  },
  mounted () {
    this.$api.session.refresh().then(signedIn => {
      this.signedIn = signedIn
      this.editor = this.$api.session.role('e')
      this.admin = this.$api.session.role('a')
    })
  },
  methods: {
    refreshData () {
      var video = this.edits.video
      if (video) {
        this.formData.platform = video.p
        this.formData.remote_id = video.i
        this.formData.category = video.c
        this.formData.description = video.d
        this.formData.editor_choice = video.e
        this.formData.locked = !!video.l
        this.videoSongs = video.sng ? video.sng.slice(0) : []
      } else {
        this.resetData()
      }
    },
    resetData () {
      this.formData.platform = null
      this.formData.remote_id = null
      this.formData.category = null
      this.formData.description = null
      this.formData.editor_choice = null
      this.formData.locked = false
      this.videoSongs = []
    },
    submit () {
      this.busy = true
      var promise
      var video = this.edits.video
      if (video && video.id) {
        promise = this.$api.videos.update(video.id, this.formData)
      } else {
        promise = this.$api.videos.create(this.formData)
      }
      return promise
        .then(savedVideo => {
          var video = this.$database.videos.update(savedVideo)
          this.$database.videos.array.sort(sortByNewestVideo)
          return video
        })
        .then(video => {
          setVideoSongs(video, false)
          this.close()
          this.busy = false
        })
        .catch(error => {
          console.log(error)
          this.busy = false
        })
    },
    close () {
      this.edits.videoModal = false
    },
    addSong () {
      this.videoSongs.push({
        id: -generateUniqueId(), // negative ID = new. It will be replaced on save
        sng: null,
        s: null,
        e: null
      })
    }
  },
  components: {
    VideoSongEdit: () => import(/* webpackChunkName: "editors.nopf" */ '../components/VideoSongEdit.vue')
  },
  watch: {
    'edits.videoModal': function (val) {
      if (val === true) {
        this.refreshData()
      } else {
        this.resetData()
        this.edits.video = null
        this.edits.song = null
      }
    },
    'edits.song': function (song) {
      if (song) {
        this.formData.song_id = song.id
      } else {
        this.formData.song_id = null
      }
    }
  }
}

</script>

<style lang="stylus">
.video-song-list {
  width: 100%;

  caption {
    background-color: black;
    border-bottom: 1px solid grey;
    text-align: center;
    text-transform: uppercase;
    font-size: 16px;
  }

  tr {
    border: 1px solid grey;
  }

  th, td {
    border-bottom: 1px solid grey;
  }

  th:first-child, td:first-child {
    text-align: left;
  }

  th, td, caption {
    font-weight: 300;
  }
}
</style>
